<template>
  <section v-home-reveal class="studio" :aria-label="t('homeStudioTitle')">
    <div class="copy">
      <h2>{{ t('homeStudioTitle') }}</h2>
      <p>{{ t('homeStudioText') }}</p>
    </div>

    <ul>
      <li v-for="tool in tools" :key="tool.titleKey" :style="{ '--accent': tool.accent }">
        <span class="icon" aria-hidden="true">
          <svg v-if="tool.icon === 'analysis'" viewBox="0 0 24 24">
            <circle cx="12" cy="12" r="8.5" fill="none" stroke="currentColor" stroke-width="1.6" />
            <circle cx="12" cy="12" r="3" fill="currentColor" />
          </svg>
          <svg v-else-if="tool.icon === 'wardrobe'" viewBox="0 0 24 24">
            <rect
              x="4"
              y="4"
              width="7"
              height="7"
              rx="1.6"
              fill="none"
              stroke="currentColor"
              stroke-width="1.6"
            />
            <rect
              x="13"
              y="4"
              width="7"
              height="7"
              rx="1.6"
              fill="none"
              stroke="currentColor"
              stroke-width="1.6"
            />
            <rect
              x="4"
              y="13"
              width="7"
              height="7"
              rx="1.6"
              fill="none"
              stroke="currentColor"
              stroke-width="1.6"
            />
            <rect x="13" y="13" width="7" height="7" rx="1.6" fill="currentColor" />
          </svg>
          <svg v-else viewBox="0 0 24 24">
            <path
              d="M12 3c2.8 4.2 6.5 8.2 6.5 11.2A6.5 6.5 0 0 1 12 21a6.5 6.5 0 0 1-6.5-6.8C5.5 11.2 9.2 7.2 12 3Z"
              fill="none"
              stroke="currentColor"
              stroke-width="1.6"
              stroke-linejoin="round"
            />
          </svg>
        </span>
        <h3>{{ t(tool.titleKey) }}</h3>
        <p>{{ t(tool.bodyKey) }}</p>
      </li>
    </ul>
  </section>
</template>
<script lang="ts">
import { defineComponent } from 'vue';
import { useI18n } from 'vue-i18n';
import { HOME_STUDIO_TOOLS } from './home.data';
import { vHomeReveal } from './home-reveal';

export default defineComponent({
  directives: {
    homeReveal: vHomeReveal,
  },
  setup() {
    const { t } = useI18n();

    return {
      t,
      tools: HOME_STUDIO_TOOLS,
    };
  },
});
</script>
<style scoped lang="scss">
.studio {
  margin: 8px 0 72px;
}

.copy {
  max-width: 46ch;
  margin: 0 0 28px;
  text-align: left;
}

h2 {
  margin: 0 0 10px;
  font-size: clamp(1.7rem, 3.6vw, 2.7rem);
  font-weight: 600;
  letter-spacing: -0.045em;
  line-height: 1.05;
}

.copy p {
  margin: 0;
  font-size: 1rem;
  line-height: 1.55;
  color: rgba(246, 243, 238, 0.76);
}

ul {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 12px;
  margin: 0;
  padding: 0;
  list-style: none;
}

li {
  padding: 22px 20px 24px;
  border: 1px solid rgba(246, 243, 238, 0.12);
  border-radius: 24px;
  background: rgba(20, 16, 24, 0.48);
  text-align: left;
  transition: transform 0.35s ease, border-color 0.35s ease;
}

li:hover {
  transform: translateY(-4px);
  border-color: rgba(246, 243, 238, 0.24);
}

.icon {
  display: grid;
  place-items: center;
  width: 42px;
  height: 42px;
  margin: 0 0 16px;
  border-radius: 12px;
  color: var(--accent);
  background: rgba(246, 243, 238, 0.06);
}

li:nth-child(1) .icon {
  background: rgba(250, 73, 110, 0.16);
}

li:nth-child(2) .icon {
  background: rgba(166, 126, 255, 0.16);
}

li:nth-child(3) .icon {
  background: rgba(82, 219, 255, 0.16);
}

.icon svg {
  width: 22px;
  height: 22px;
  display: block;
}

h3 {
  margin: 0 0 8px;
  font-size: 17px;
  font-weight: 600;
  letter-spacing: -0.02em;
}

li p {
  margin: 0;
  font-size: 14px;
  line-height: 1.5;
  color: rgba(246, 243, 238, 0.72);
}

@media (max-width: 800px) {
  ul {
    grid-template-columns: 1fr;
  }
}

@media (prefers-reduced-motion: reduce) {
  li {
    transition: none;
  }

  li:hover {
    transform: none;
  }
}
</style>
